var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidbaricon4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1668 7.3335V6.66683C13.1668 4.15267 13.1668 2.8956 12.3857 2.11454C11.6047 1.3335 10.3476 1.3335 7.83347 1.3335H7.16687C4.65272 1.3335 3.39565 1.3335 2.6146 2.11454C1.83356 2.89558 1.83354 4.15264 1.83352 6.66678L1.8335 9.3335C1.83348 11.8476 1.83347 13.1047 2.61449 13.8858C3.39554 14.6668 4.65266 14.6668 7.1668 14.6668",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8335 4.6665H10.1668M4.8335 7.99984H10.1668",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8335 13.8847V14.6668H9.61576C9.8887 14.6668 10.0252 14.6668 10.1478 14.616C10.2706 14.5652 10.367 14.4687 10.56 14.2758L13.7758 11.0598C13.9578 10.8778 14.0488 10.7868 14.0974 10.6886C14.19 10.5018 14.19 10.2826 14.0974 10.0958C14.0488 9.99756 13.9578 9.90656 13.7758 9.72456C13.5937 9.54256 13.5027 9.45156 13.4045 9.4029C13.2177 9.31036 12.9984 9.31036 12.8116 9.4029C12.7134 9.45156 12.6224 9.54256 12.4404 9.72456L9.22463 12.9406C9.0317 13.1335 8.93516 13.23 8.88436 13.3526C8.8335 13.4754 8.8335 13.6118 8.8335 13.8847Z",
    stroke: "white",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidbaricon4);
export default __webpack_public_path__ + "static/media/sidbaricon4.8e41d5772fef84bcd7149c9eb5193d42.svg";
export { ForwardRef as ReactComponent };